import React, { SyntheticEvent, useState } from 'react';
import { Container, MenuItem, Select } from '@mui/material';

import StyledSearchMenu from './styles';
import CustomButton from '../../../../../components/CustomButton';
import CustomDatePicker from '../../../../../components/CustomDatePicker';
import Label from '../../../../../components/Label';
import StyledFormControl from '../../../../../components/ControlledSelect/styles';
import ProductCodeSearch from '../../../../../components/ProductCodeSearch';
import SkuGroupSearch from '../../../../../components/SkuGroupSearch';
import { isValid } from 'date-fns';

interface ISearchMenuProps {
  productCodes: string[];
  setProductCodes: CallableFunction;
  stockPot: string;
  setStockPot: CallableFunction;
  subinventories: string[];
  status: string;
  setStatus: CallableFunction;
  statuses: string[];
  snapshotDate: Date | null;
  setSnapshotDate: CallableFunction;
  handleSubmit: (event: SyntheticEvent) => void;
}

const StockAlignmentSearchMenu: React.FC<ISearchMenuProps> = ({
  productCodes,
  setProductCodes,
  stockPot,
  setStockPot,
  subinventories,
  status,
  setStatus,
  statuses,
  snapshotDate,
  setSnapshotDate,
  handleSubmit
}) => {
  const [skuGroupNames, setSkuGroupNames] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [invalidDate, setInvalidDate] = useState<boolean>(false);

  const clearSearchOptions = () => {
    setProductCodes([]);
    setSkuGroupNames([]);
    setStockPot('');
    setStatus('');
    setSnapshotDate(null);
    setErrorMessage('');
    setInvalidDate(false);
  };

  return (
    <StyledSearchMenu>
      <Container fixed>
        <h2>Search Items</h2>
        <form noValidate autoComplete='off' onSubmit={handleSubmit}>
          <div className='search-menu-row'>
            <SkuGroupSearch
              productCodes={productCodes}
              setProductCodes={setProductCodes}
              skuGroupNames={skuGroupNames}
              setSkuGroupNames={setSkuGroupNames}
              style={{ width: '100%' }}
            />
          </div>
          <br />
          <div className='search-menu-row'>
            <ProductCodeSearch
              productCodes={productCodes}
              setProductCodes={setProductCodes}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              style={{ width: '50%' }}
            />
          </div>
          <hr />
          <div className='search-menu-row'>
            <Label
              id='sub-inventory'
              control={
                <StyledFormControl variant={'outlined' as any}>
                  <Select
                    data-testid='select-testid'
                    displayEmpty
                    value={stockPot}
                    onChange={(event: any) => setStockPot(event.target.value)}
                  >
                    <MenuItem key='placeholder' value=''>
                      Select sub-inventory
                    </MenuItem>
                    {subinventories.map((option: string) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              }
              label='Sub-inventory'
              classes='label--w-30'
            />
            <Label
              id='status'
              control={
                <StyledFormControl variant={'outlined' as any}>
                  <Select
                    data-testid='select-testid'
                    displayEmpty
                    value={status}
                    onChange={(event: any) => setStatus(event.target.value)}
                  >
                    <MenuItem key='placeholder' value=''>
                      Select status
                    </MenuItem>
                    {statuses.map((option: string) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              }
              label='Status'
              classes='label--w-30'
            />
            <CustomDatePicker
              id='start-date'
              value={snapshotDate}
              handleChange={(event: any) => {
                setInvalidDate(!isValid(new Date(event)));
                setSnapshotDate(event);
              }}
              label='Snapshot date'
              classes='label--w-30'
            />
          </div>
          <hr />
          <div className='search-menu-row'>
            <div className='search-btn-wrapper'>
              <CustomButton
                type='button'
                classes='btn--w-200-px btn--light-grey clear-btn'
                title='Clear'
                handleClick={() => clearSearchOptions()}
              />
            </div>
            <CustomButton
              type='submit'
              classes='btn--w-200-px'
              title='Search'
              disabled={invalidDate}
            />
          </div>
        </form>
      </Container>
    </StyledSearchMenu>
  );
};

export default StockAlignmentSearchMenu;
